var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bv-row",attrs:{"fluid":""}},[_c('b-row',{},[_c('b-col',{staticStyle:{"padding-left":"5px","padding-right":"5px","margin-top":"5px","margin-bottom":"5px"},attrs:{"cols":"12"}},[_c('transition',[_c('keep-alive',[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }